"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldResetAmountsAfterDelete = shouldResetAmountsAfterDelete;
const types_1 = require("../types");
function shouldResetAmountsAfterDelete(outcomesLength, betType) {
    return outcomesLength === 2 && betType !== types_1.EBetTypes.Ordinar;
}
//# sourceMappingURL=shouldResetAmountsAfterDelete.js.map